import script from "./HeaderDesktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderDesktop.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderDesktop.vue?vue&type=style&index=0&id=aab41be8&lang=scss"

const __exports__ = script;

export default __exports__